import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { map } from 'rxjs/operators';
import {
  IProductDocumentsGETModel,
  IProductDocumentsPOSTModel,
  IProductDocumentsPUTModel,
} from '../../models/product/dto/documents/product-documents.model';

@Injectable({
  providedIn: 'root',
})
export class ProductDocumentsService {
  fullPath: string;
  // private mapping: ProductPhotosMapping;

  constructor(
    private readonly httpClient: HttpClient,
    public envService: EnvironmentService
  ) 
  {
    this.fullPath = `${envService.settings.apiUrl}/products`;
    // this.mapping = new ProductPhotosMapping();
  }

  public get(id: number): Observable<IProductDocumentsGETModel[]> {
    return this.httpClient
      .get<any>(
        `${this.fullPath}/${id}/documents`
      )
      .pipe(
        map((dto) =>
          dto['items'].map(
            (dto: IProductDocumentsGETModel) =>
              // this.mapping.toApplicationModel(dto)
              dto
          )
        )
      );
  }

  public save(
    id: number,
    model: IProductDocumentsPOSTModel
  ): Observable<IProductDocumentsPOSTModel> {
    return this.httpClient.post<IProductDocumentsPOSTModel>(
      `${this.fullPath}/${id}/document`,
      model
    );
  }

  public update(
    model: IProductDocumentsPUTModel
  ): Observable<IProductDocumentsPUTModel> {
    return this.httpClient.put<IProductDocumentsPUTModel>(
      `${this.fullPath}/${model.productId}/document/${model.documentId}`,
      model
    );
  }

  public delete(productId: number, documentIds: number[]) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: {
        productId: productId,
        documentIds: documentIds,
      },
    };
    return this.httpClient.delete(
      `${this.fullPath}/${productId}/documents/`,
      httpOptions
    );
  }
}
